import React from "react";
import { AWARDS } from "../mock/mock";
import { ArrowRight, Award } from "lucide-react";
import { useBooking } from "../context/BookingContext";

export default function Expert() {
  const { openBook } = useBooking();
  return (
    <section className="py-24 md:py-32 bg-viimii-2">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal relative order-2 lg:order-1">
          <div className="relative overflow-hidden border hairline" style={{ borderRadius: "260px 260px 28px 28px" }}>
            <img src="/studio/owner.jpeg" alt="Founder of VIIMII STUDIO" className="w-full h-[560px] object-cover" />
          </div>
          <div className="absolute top-6 -left-3 md:left-6 bg-viimii border hairline rounded-2xl px-6 py-4 text-center shadow-2xl">
            <div className="font-display text-3xl gold-gradient-text">3K+</div>
            <div className="text-[11px] text-cream/55 tracking-wide">Clients Served</div>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <p className="section-line text-gold mb-4">Meet the Expert</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            The artist behind <span className="gold-gradient-text italic">VIIMII.</span>
          </h2>
          <p className="mt-6 text-cream/70 leading-relaxed">
            Hi, I'm <span className="text-cream font-medium">Mou</span> - the hands and heart behind VIIMII STUDIO.
            I began this journey in February 2023 with one simple love: making people feel
            good about themselves.
          </p>
          <p className="mt-4 text-cream/70 leading-relaxed">
            What I love most is getting to know you - your style, your comfort, the little
            things you like - and creating something that's made just for you, never a
            copy-paste set. Every nail, lash and hair ritual here is done with patience and
            genuine care, because to me you're never just an appointment. You're the reason
            VIIMII exists.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {AWARDS.map((a) => (
              <div key={a.title} className="flex gap-3 p-4 rounded-2xl border hairline bg-viimii">
                <Award size={20} className="text-gold shrink-0 mt-0.5" style={{ color: "var(--viimii-gold)" }} />
                <div>
                  <h4 className="text-sm font-medium text-cream">{a.title}</h4>
                  <p className="text-xs text-cream/55 mt-0.5">{a.sub}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={openBook}
            className="group mt-9 inline-flex items-center gap-3 bg-gold text-black font-medium px-7 py-4 rounded-full hover:gap-4 transition-all duration-300"
            style={{ background: "var(--viimii-gold)" }}
          >
            Book Appointment <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
